// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manageTemplate__JciDZ {
  height: 100%;
}

.manageTemplateBody__HgHkw {
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  height: calc(100vh - 160px);
  overflow-y: auto;
}
.manageTemplateBody__HgHkw::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.manageTemplateBody__HgHkw::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.manageTemplateBody__HgHkw::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.manageTemplateBody__HgHkw::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 900px) {
  .manageTemplateBody__HgHkw {
    padding: 15px;
    gap: 15px;
  }
}

.messageBlock__WtsI8 {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  color: var(--header-title-secondary);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageTemplate/style.module.scss"],"names":[],"mappings":"AA4EA;EACE,YAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;AA3EF;AAeE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,+BAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,8BAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,kBAAA;AAhBJ;AA8DE;EAVF;IAWI,aAAA;IACA,SAAA;EA3DF;AACF;;AA8DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AA3DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.manageTemplate {\n  height: 100%;\n}\n\n.manageTemplateBody {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n\n  @include scrollBar;\n\n  @media (max-width: 900px) {\n    padding: 15px;\n    gap: 15px;\n  }\n}\n\n.messageBlock {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--header-title-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageTemplate": `manageTemplate__JciDZ`,
	"manageTemplateBody": `manageTemplateBody__HgHkw`,
	"messageBlock": `messageBlock__WtsI8`
};
module.exports = ___CSS_LOADER_EXPORT___;
